import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Tabs from 'react-bootstrap/esm/Tabs';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form';
import { Table } from 'react-bootstrap';
// others
import Select from 'react-select'
import { minedexCommodoties, minedexTargetComodotiy, minedexSiteType } from './MinedexTypeData';
import { createSingleMinedexPopupTable, lookupSingleSiteCode } from './MinedexOverlay';
import * as turf from "@turf/turf";

export const getMinedexCommodityCategoryFilterDefaults = () => {
    return [{ "label": "PRECIOUS METAL", "value": "PRECIOUS METAL" }]
}

export const getMinedexTargetCategoryFilterDefaults = () => {
    return [{ "label": "GOLD", "value": "GOLD" }]
}

export const getMinedexSiteTypeDefaults = () => {
    const out = minedexSiteType.map((e) => {
        return { label: e, value: e }
    });

    return out;
}

export function MinedexQueryTool({ minedexFilters, setMinedexFilters, goldfindermap, setMinedexPopup, setShowMinedexPopup }) {

    const SelectCustomStyles = {
        // https://codesandbox.io/p/sandbox/react-select-valuecontainer-with-max-height-17b26?file=%2Fsrc%2FApp.js%3A28%2C5
        valueContainer: (base) => ({
            ...base,
            maxHeight: 200,
            overflowY: "auto"
        })
    };

    const getMinedexCommodityCategories = () => {
        return minedexCommodoties.map((e) => {
            return { label: e.commodityId, value: e.commodityId }
        });
    }

    const getMinedexTargetComodities = () => {
        return minedexTargetComodotiy.map((e) => {
            return { label: e, value: e }
        });
    }

    const getMinedexSiteTypes = () => {
        return minedexSiteType.map((e) => {
            return { label: e, value: e }
        });
    }

    const minedexCommodotyCategory = getMinedexCommodityCategories();
    const minedexTargetCommodoty = getMinedexTargetComodities();
    const minedexSiteTypes = getMinedexSiteTypes();


    const setSelectedCommodityCategories = (typesIn) => {
        setMinedexFilters({ ...minedexFilters, commodityCategory: typesIn })
    }

    const setSelectedTargetComodity = (typesIn) => {
        setMinedexFilters({ ...minedexFilters, targetCommodity: typesIn })
    }

    const setSelectedSiteType = (typesIn) => {
        setMinedexFilters({ ...minedexFilters, siteType: typesIn })
    }


    const LookupSiteCode = (e) => {
        e.preventDefault()

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        lookupSingleSiteCode(data.sitecode).then((e) => {
            // should be able to get around this by querying turf.js
            // use turn founds to fly to.
            const turfBounds = turf.bbox(e.data);
            goldfindermap.fitBounds([
                [turfBounds[0], turfBounds[1]],
                [turfBounds[2], turfBounds[3]]])
            setMinedexPopup(createSingleMinedexPopupTable(e.data.features[0], {lat:e.data.features[0].geometry.coordinates[1], lng:e.data.features[0].geometry.coordinates[0]}, setShowMinedexPopup));
        });
    };

    const toggleIncludeSiteStageUndeveloped = () => {
        setMinedexFilters({ ...minedexFilters, siteStageUndeveloped: !minedexFilters.siteStageUndeveloped });
    }
    const toggleIncludeSiteStageProposed = () => {
        setMinedexFilters({ ...minedexFilters, siteStageProposed: !minedexFilters.siteStageProposed });
    }
    const toggleIncludeSiteStageUnderDevelopment = () => {
        setMinedexFilters({ ...minedexFilters, siteStageUnderDevelopment: !minedexFilters.siteStageUnderDevelopment });
    }
    const toggleIncludeSiteStageCareAndMaint = () => {
        setMinedexFilters({ ...minedexFilters, siteStageCareAndMaint: !minedexFilters.siteStageCareAndMaint });
    }
    const toggleIncludeSiteStageOperating = () => {
        setMinedexFilters({ ...minedexFilters, siteStageOperating: !minedexFilters.siteStageOperating });
    }
    const toggleIncludeSiteStageShut = () => {
        setMinedexFilters({ ...minedexFilters, siteStageShut: !minedexFilters.siteStageShut });
    }

    return (
        <div>
            <Tabs className='mb-2'>
                <Tab eventKey='simple' title='Simple Query'>
                    <Form onSubmit={(e) => LookupSiteCode(e)} >
                        <Form.Label style={{ fontSize: 12 }} column="sm" >Site Code (i.e. SXXXXXXX)</Form.Label>
                        <Row className='mb-2'>
                            <Col>
                                <Form.Control size="sm" name='sitecode' type='text' required />

                            </Col>
                            <Col>
                                <button className="btn btn-primary btn-sm" type="submit">Lookup</button>
                            </Col>
                        </Row>
                    </Form>
                </Tab>
                <Tab eventKey='advanced' title='Advanced Query'>
                    <Form.Label column="sm">
                        Site Type
                    </Form.Label>
                    <Select isMulti='true'
                        defaultValue={minedexFilters.siteType}
                        onChange={setSelectedSiteType}
                        options={minedexSiteTypes}
                        styles={SelectCustomStyles}
                        required  >
                    </Select >
                    <Form.Label column="sm">
                        Site Stage
                    </Form.Label>
                    <Row>
                        <Col>
                            <Form.Check
                                id='include_sitestage_UnderDevelopment'
                                name='include_sitestage_UnderDevelopment'
                                label='Under Development'
                                checked={minedexFilters.siteStageUnderDevelopment}
                                onChange={toggleIncludeSiteStageUnderDevelopment}
                            />
                            <Form.Check
                                id='include_sitestage_siteStageCareAndMaint'
                                name='include_sitestage_siteStageCareAndMaint'
                                label='Care And Maintenence'
                                checked={minedexFilters.siteStageCareAndMaint}
                                onChange={toggleIncludeSiteStageCareAndMaint}
                            />
                            <Form.Check
                                id='include_sitestage_Undeveloped'
                                name='include_sitestage_Undeveloped'
                                label='Undeveloped'
                                checked={minedexFilters.siteStageUndeveloped}
                                onChange={toggleIncludeSiteStageUndeveloped}
                            />
                        </Col>
                        <Col>
                            <Form.Check
                                id='include_sitestage_Operating'
                                name='include_sitestage_Operating'
                                label='Operating'
                                checked={minedexFilters.siteStageOperating}
                                onChange={toggleIncludeSiteStageOperating}
                            />
                            <Form.Check
                                id='include_sitestage_Shut'
                                name='include_sitestage_Shut'
                                label='Shut'
                                checked={minedexFilters.siteStageShut}
                                onChange={toggleIncludeSiteStageShut}
                            />
                            <Form.Check
                                id='include_sitestage_Proposed'
                                name='include_sitestage_Proposed'
                                label='Proposed'
                                checked={minedexFilters.siteStageProposed}
                                onChange={toggleIncludeSiteStageProposed}
                            />
                        </Col>
                    </Row>

                    <Form.Group className='mb-3'>
                        <Form.Label column="sm">
                            Category
                        </Form.Label>
                        <Select isMulti='true'
                            defaultValue={minedexFilters.commodityCategory}
                            onChange={setSelectedCommodityCategories}
                            options={minedexCommodotyCategory}
                            styles={SelectCustomStyles}
                            required  >
                        </Select >
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label column="sm">
                            Target Commodity
                        </Form.Label>
                        <Select isMulti='true'
                            defaultValue={minedexFilters.targetCommodity}
                            onChange={setSelectedTargetComodity}
                            options={minedexTargetCommodoty}
                            styles={SelectCustomStyles}
                            required  >
                        </Select >
                    </Form.Group>
                </Tab>
                <Tab eventKey='legend' title='Legend'>
                    <Table striped bordered >
                        <thead>
                            <tr>
                                <th>Map Icon</th>
                                <th>Commodity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {minedexCommodoties.map((c) => {
                                return <tr>
                                    <td style={{ textAlign: 'center' }}>
                                        <i className={c.iconClassName} style={{ color: c.color }} />
                                    </td>
                                    <td>
                                        {c.commodityId}
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Tab>
            </Tabs>
        </div>
    )

}